// Foundations
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { PackageItem } from 'src/app/models/package/package-item.model';

@Component({
  selector: 'app-package-item',
  templateUrl: './package-item.component.html',
  styleUrls: ['./package-item.component.scss']
})
export class PackageItemComponent implements OnInit {

  @Input() packageItem: PackageItem;
  @Input() showDelete: false;
  @Output() toggleSelection  = new EventEmitter<PackageItem>();

  ACTIVE_CHECK_PATH = 'assets/svg/ico_check_solid.svg';
  INACTIVE_CHECK_PATH = 'assets/svg/ico_check_solid_white.svg';

  constructor(
  ) { }

  // Life cycles
  // ------------------------------------------------------------------------------------

  ngOnInit(): void {
  }

  // Public Methods
  // ------------------------------------------------------------------------------------

  toggleSelected(): void {
    this.toggleSelection.emit(this.packageItem);
  }

  get getCheckPath(): string {
    return this.packageItem.isSelected ? this.ACTIVE_CHECK_PATH : this.INACTIVE_CHECK_PATH;
  }
}
